/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';

    const constants = require('@utils/_constants');
    var app = angular.module('enervee');

    app.directive('utilityStateSelector', [function() {
        return {
            restrict:'E',
            scope: {
                isMobile: '@'
            },
            template: require('@app/shared/utilityStateSelector/utilityStateSelectorView.html'),
            controller: [
                '$scope',
                '$timeout',
                '$http',
                'AccountAuthService',
                'CategoriesService',
                'CmsContentService',
                'UtilitySelectorService',
                'UtilitySelectorCookieService',
                'UtilService',
                function(
                    $scope,
                    $timeout,
                    $http,
                    AccountAuthService,
                    CategoriesService,
                    CmsContentService,
                    UtilitySelectorService,
                    UtilitySelectorCookieService,
                    UtilService
                ) {
                    var isUtilitySet = UtilitySelectorCookieService.isElectricalUtilitySet();

                    /**
                     * Example default utility state format:
                     *
                     * {
                     *     "electrical_rate": 10,
                     *     "id": 12340,
                     *     "title": "Avista Corp",
                     *     "state_code": "WA"
                     *     "postal_code": 98119
                     * }
                     */
                    var defaultUtilityState = UtilService.getSiteSetting('default_utility_state');
                    var utilityZipCodes = UtilService.getSiteSetting('utility_zipcodes', {});
                    $scope.showUtilityRate = UtilService.getSiteSetting('show_state_utility_rate', false);
                    let utilityOtherStatesPopoverAutoShow = UtilService.getSiteSetting('utility_other_states_popover_auto_show', true);
                    let utilityOtherStatesLinks = UtilService.getSiteSetting('utility_other_states_links', null);

                    /**
                     * Populates the website links of the same utility in other states
                     */
                    $scope.utilityOtherStatesLinks = null;
                    if (utilityOtherStatesLinks && (Object.keys(utilityOtherStatesLinks).length > 0)) {
                        $scope.utilityOtherStatesLinks = utilityOtherStatesLinks;
                    }

                    $scope.loadingUtilityStateProviders = true;
                    /**
                     * Shows or hides the "(electrical)" and "(gas)" labels
                     */
                    $scope.showPowerLabel = false;

                    // Eager load the text for the popover
                    CmsContentService.retrieveCMSContent('utility_state_picker');

                    /**
                     * Utility selector popover display options
                     */
                    $scope.utilityStateSelectorPopover = {
                        isOpen: true,
                        isEnabled: true,
                        templateUrl: '/app/shared/popovers/utilityStateSelectorPopover.html'
                    };

                    $scope.utilityStateSelectorStates = {
                        stateDetail: 'detail',
                        stateList: 'list',
                        stateSearch: 'search',
                    };

                    /**
                     * Helper function to check the current state of the popover.
                     * @param state
                     * @returns {boolean}
                     */
                    $scope.checkPopoverState = function(state) {
                        return $scope.utilityStateSelectorState === state;
                    };

                    /**
                     * Helper function to show a new popover
                     * @param state
                     */
                    $scope.setPopoverState = function(state) {
                        $scope.utilityStateSelectorState = state;
                        if (state === $scope.utilityStateSelectorStates.stateList) {
                            UtilitySelectorService.getUtilityProviders().then(function(utilityProviders) {
                                $scope.utilityStateProviders = utilityProviders;
                                $scope.loadingUtilityStateProviders = false;
                            });
                        }
                    };

                    /**
                     * Set the initial state for the popover
                     */
                    $scope.setPopoverState($scope.utilityStateSelectorStates.stateDetail);

                    /**
                     * Helper function to dismiss the popover.
                     */
                    $scope.hidePopover = function() {
                        if (!isUtilitySet) {
                            $scope.selectUtility(defaultUtilityState);
                        }
                        $scope.utilityStateSelectorPopover.isOpen = false;
                        $scope.resetPopoverState();
                    };

                    /**
                     * Helper function to show the popover.
                     */
                    $scope.showPopover = function() {
                        $scope.utilityStateSelectorPopover.isOpen = true;
                    };

                    /**
                     * Helper function to toggle the popover to hide or display.
                     */
                    $scope.togglePopover = function() {
                        if ($scope.utilityStateSelectorPopover.isOpen) {
                            $scope.hidePopover();
                        } else {
                            $scope.showPopover();
                        }
                    };

                    /**
                     * Convenience function to get title for popover from CMS.
                     * @param utility
                     * @private
                     */
                    var getTitleFromCMS = function (utility) {
                        var titleNameLocation  = 'base:header:utility_selector_title';
                        if ($scope.isMobile) {
                            titleNameLocation = 'base:header:utility_selector_title_mobile';
                        }
                        CmsContentService.getMarketPlaceText(titleNameLocation).then(function(text) {
                            if (text !== "") {
                                $scope.title = text;
                            }
                        }, function() {
                            $scope.title = utility.title;
                        });
                    };

                    /**
                     * Convenience function to set the chosen utility info in the header.
                     * @param utility
                     * @private
                     */
                    var _setUtilityHeaderInfo = function(utility) {
                        $scope.utilityState = utility;
                        $scope.title = utility.title;
                        getTitleFromCMS(utility);
                    };

                    /**
                     * Set a user utility. Sets utility from the utilityProviders list
                     * @param utility
                     */
                    $scope.selectUtility = function(utility) {
                        // If there are utility zipcodes set, see if there's a specific zipcode for this utility
                        var state = utility.state_code.toLowerCase();
                        if (state in utilityZipCodes) {
                            utility.postal_code = utilityZipCodes[state];
                        }
                        _setUtilityHeaderInfo(utility);
                        utility.electrical_utility_id = utility.id;
                        UtilitySelectorCookieService.setElectricalUtility(utility);
                        if (AccountAuthService.isAuthenticated()) {
                            UtilitySelectorService.setElectricalUtility(utility);
                        } else {
                            AccountAuthService.onAuthChange(utility, constants.EVENT_SET_ELECTRICAL_UTILITY);
                        }
                        isUtilitySet = true;
                        $scope.hidePopover();
                    };

                    $scope.resetPopoverState = function() {
                        // Wait for fade out animations to complete
                        $timeout(function() {
                            // Don't switch states if the popover is open
                            if (!$scope.utilityStateSelectorPopover.isOpen) {
                                $scope.setPopoverState($scope.utilityStateSelectorStates.stateDetail);
                            }
                        }, 400);
                    };

                    $scope.activeCategory = CategoriesService.getActiveCategory();
                    $scope.gasPoweredCategory = false;
                    $scope.$watch('categorySet', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                           $scope.activeCategory = newVal;
                           $scope.gasPoweredCategory = UtilService.getSetting('gasPoweredCategories', []).indexOf(newval.id) > -1;
                        }
                    }, true);

                    /**
                     * Set the initial state of the widget
                     */
                    if (!isUtilitySet) {
                        $scope.utilityState = defaultUtilityState;
                        $scope.selectUtility(defaultUtilityState);
                        UtilitySelectorService.getUtilityProviders().then(function(utilityProviders) {
                            $scope.utilityStateProviders = utilityProviders;
                            $scope.loadingUtilityStateProviders = false;
                            if ($scope.utilityStateProviders.length > 0) {
                                if ($scope.utilityStateProviders.length > 1) {
                                    // Multiple utilities found, list the utilities
                                    $scope.setPopoverState($scope.utilityStateSelectorStates.stateList);
                                } else {
                                    // One utility found, display the confirmation popover box
                                    var utility = $scope.utilityStateProviders[0];
                                    _setUtilityHeaderInfo(utility.electrical_utility_title, utility.electrical_rate);
                                    $scope.setPopoverState($scope.utilityStateSelectorStates.stateDetail);
                                }
                            } else {
                                // GEOIP did not find a utility - Default is displayed
                            }

                        });
                    } else {
                        // User has set a utility, hide the popover and set the utility info in the header
                        $scope.hidePopover();
                        var utility = UtilitySelectorCookieService.getElectricalUtility();
                        if ('electrical_rate' in utility || 'gas_rate' in utility) {
                            _setUtilityHeaderInfo(utility);
                        }
                    }

                    /**
                     * Auto-shows the state selector popover
                     */
                    if (utilityOtherStatesPopoverAutoShow) {
                        $scope.showPopover();
                    }
                }
            ]
        };
    }]);
})(angular);
